import React from 'react';
import { ArrowLeft } from 'lucide-react';
import './FooterPages.css';

const ContactUs = ({ onBack }) => {
  return (
    <div className="footer-page">
      <button className="back-button" onClick={onBack}>
        <ArrowLeft size={20} />
        Back
      </button>
      <div className="footer-page-content">
        <h1>Contact Us</h1>
        <p className="placeholder-text">Content coming soon...</p>
      </div>
    </div>
  );
};

export default ContactUs;
